
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clothes-changer",
      function () {
        return require("private-next-pages/clothes-changer/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clothes-changer"])
      });
    }
  